import type { TOC } from '@ember/component/template-only';

import type { ComponentLike } from '@glint/template';

import NotificationsEditFormBaseComponent, {
	type ChunkInterface,
	type MainChunkInterface,
} from 'webapp/components/notifications/edit/form/base';
import MainComponent, {
	type ValidationErrorsType,
} from 'webapp/components/notifications/edit/form/reminder/main';

import type { Reminder } from 'webapp/models-custom';

const TitleComponent: TOC<ChunkInterface> = <template></template>;

export default class NotificationsEditFormReportReminderComponent extends NotificationsEditFormBaseComponent {
	get model() {
		return this.args.model as Reminder;
	}

	get errors() {
		return this.args.errors as ValidationErrorsType;
	}

	get titleComponent() {
		return TitleComponent as ComponentLike<ChunkInterface>;
	}

	get mainComponent() {
		return MainComponent as ComponentLike<MainChunkInterface>;
	}
}
